import { render, staticRenderFns } from "./BackupQuotes.vue?vue&type=template&id=7d8a5863&"
import script from "./BackupQuotes.vue?vue&type=script&lang=js&"
export * from "./BackupQuotes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports